import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UserType } from 'src/app/components/profile/profile.enum';
import { OrganizationDisplayedInfo, RoleDisplayedInfo } from 'src/app/interfaces/profile.interface';
import { Doctor, MedStaff, Patient, Researcher } from 'src/app/swagger-api';

@Component({
  selector: 'app-user-role-tab',
  templateUrl: './user-roles.component.html',
  styleUrls: ['./user-roles.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserRoleTabComponent {
  @Input({ required: true }) public role: RoleDisplayedInfo;

  public get doctor(): Doctor {
    return this.role.doctor || ({} as Doctor);
  }

  public get patient(): Patient {
    return this.role.patient || ({} as Patient);
  }

  public get medStaff(): MedStaff {
    return this.role.med_staff || ({} as MedStaff);
  }

  public get researcher(): Researcher {
    return this.role.researcher || ({} as Researcher);
  }

  public get organization(): OrganizationDisplayedInfo {
    return this.role.organization || ({} as OrganizationDisplayedInfo);
  }

  public readonly USER_TYPE_PATIENT: string = UserType.patient;
  public readonly USER_TYPE_DOCTOR: string = UserType.doctor;
  public readonly USER_TYPE_MED_STAFF: string = UserType.med_staff;
  public readonly USER_TYPE_RESEARCHER: string = UserType.researcher;
  public readonly USER_TYPE_ORGANIZATION: string = UserType.organization;
}
